var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"svg-path":_vm.$options.emptyStateSvgPath,"svg-height":_vm.svgHeight,"title":_vm.title,"description":_vm.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }